import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'clsx';
import { Typography } from "../../foundation/typography/typography";
import css from "./field-label.module.css";
/**
 * The FieldLabel parent component.
 * @children Should always contain <FieldLabelText /> and an optional <FieldLabelHelpText />
 * @returns the field label to describe the input element.
 */
const FieldLabel = ({ className, children, ...restProps }) => {
    return (_jsx("label", { className: classNames(css.fieldLabel, className), ...restProps, children: children }));
};
FieldLabel.displayName = 'FieldLabel';
/**
 * The FieldLabelText component.
 * @children The text to display as the main field label text, such as 'First name' or 'Last name'
 * @returns the main field label text.
 */
const FieldLabelText = ({ className, children, ...restProps }) => {
    return (_jsx(Typography, { className: classNames(css.fieldLabelText, className), variant: "body-strong", as: "p", ...restProps, children: children }));
};
FieldLabelText.displayName = 'FieldLabelText';
/**
 * The FieldLabelHelpText component.
 * @children The text to display as help text under the main field label text.
 * @returns the help label text.
 */
const FieldLabelHelpText = ({ className, children, ...restProps }) => {
    return (_jsx(Typography, { className: classNames(css.fieldLabelHelpText, className), variant: "body-regular", as: "p", ...restProps, children: children }));
};
FieldLabelHelpText.displayName = 'FieldLabelHelpText';
export { FieldLabel, FieldLabelText, FieldLabelHelpText };
